import React from "react";
import RevenueTypeFilter from "./smartComponents/revenueType";
import MonthSwitcher from "./smartComponents/monthSwitcher";

const DashboardFiltersModule = () => {
  return (
    <div id="pageFilters">
      <MonthSwitcher />
      <RevenueTypeFilter />
    </div>
  );
};

export default DashboardFiltersModule;
